module.exports = __webpack_public_path__ + "static/media/word.ba7c70f6.png";